var main = require('./js/main.js')



// WEBPACK FOOTER //
// ./src/index.js